import script from "./TreeNode.vue?vue&type=script&setup=true&lang=js"
export * from "./TreeNode.vue?vue&type=script&setup=true&lang=js"

import "./TreeNode.vue?vue&type=style&index=0&id=db149a84&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db149a84"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
